export function target() {
  return this.module === 'NewFooter' && this.data.links;
}

export function migrate() {
  this.data.menuLinks = this.data.links.map(
    ({ openInNewTab, linkURL, ...link }) => ({
      ...link,
      linkUrl: linkURL,
      buttonOpenInNewTab: openInNewTab,
    }),
  );

  delete this.data.links;
}
